module.exports = __webpack_public_path__ + "img/icon-13.875f88af.png";